import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dim from 'web/components/common/modal/common/Dim';
import { initModal } from 'shared/actions/modal.action';

import {} from 'shared/actions/auth.action';
import EasyPenPackage from 'shared/components/modal/EasyPenPackage';

@connect((state, props) => ({}), { initModal })
class EasyPenDetailContainer extends Component {
  render() {
    return (
      <Dim onClick={this.props.initModal}>
        <EasyPenPackage initModal={this.props.initModal} />
      </Dim>
    );
  }
}

export default EasyPenDetailContainer;
